import { useState } from 'react';
// @mui
import { List, Collapse } from '@mui/material';
// type
import { NavListProps } from '../type';
//
import { NavItemRoot, NavItemSub } from './NavItem';
import { navigateToUrl } from 'single-spa';

type NavListRootProps = {
  list: NavListProps;
  isCollapse: boolean;
};

export function NavListRoot({ list, isCollapse }: NavListRootProps) {
  const active = false;

  const [open, setOpen] = useState(active);

  const handleSelectedItem = (status: boolean, path: string) => {
    setOpen(!status);
    navigateToUrl(path);
  };

  const hasChildren = list.children;

  if (hasChildren) {
    return (
      <>
        <NavItemRoot
          item={list}
          isCollapse={isCollapse}
          active={active}
          open={open}
          onOpen={() => setOpen(!open)}
        />

        {!isCollapse && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {(list.children || []).map((item) => (
                <NavListSub key={item.title + item.path} list={item} />
              ))}
            </List>
          </Collapse>
        )}
      </>
    );
  }

  return <NavItemRoot item={list} active={active} isCollapse={isCollapse} onOpen={() => handleSelectedItem(!open, list.path)}/>;
}

type NavListSubProps = {
  list: NavListProps;
};

function NavListSub({ list }: NavListSubProps) {
  const active = false;
  const [open, setOpen] = useState(active);

  const hasChildren = list.children;

  const handleSelectedItem = (status: boolean, path: string) => {
    setOpen(!status);
    navigateToUrl(path);
  };

  if (hasChildren) {
    return (
      <>
        <NavItemSub
          item={list}
          onOpen={() =>  setOpen(!open)}
          open={open}
          active={active}
        />

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{ pl: 3 }}>
            {(list.children || []).map((item) => (
              <NavItemSub
                key={item.title + item.path}
                item={item}
                active={false}
                onOpen={() => handleSelectedItem(!open, item.path)}
              />
            ))}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <NavItemSub item={list} active={active} onOpen={() => handleSelectedItem(!open, list.path)} />
  );
}
